<div *ngIf="hasGdpr() && footerSystemDoc" class="fixed-container mb20 mt10">
    <p><a style="cursor: pointer" role="button" (click)="downloadPdf()">{{footerSystemDoc.sessionLabel}}</a> </p>
</div>


